// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tBRLg6uDC7sSyw {
  display: block;
  flex-shrink: 0;
  align-self: flex-start;
  padding: 0 6px;
  height: 100%;
  white-space: nowrap;
}
.tBRLg6uDC7sSyw[hidden] {
  display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listWrapper": `tBRLg6uDC7sSyw`
};
export default ___CSS_LOADER_EXPORT___;
